import ReportSideBar from './component'

export default ReportSideBar
